import React, { useState } from 'react';
import './Style.css';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import { DesignPreview } from '../../../Components';
import { ImageLibraryAsPopup, ProductDescription } from '../..';
import { useUser } from '../../../Context/User';

const Index = ({ products, showProps, addMore }) => {
    return (
        <div style={{ overflowY: 'hidden', overflowX: 'scroll', padding: '1rem' }}>
            <table className="confirm_products_table">
                <thead className="confirm_products_table_head">
                    <tr className="confirm_products_table_head_row">
                        <td className="confirm_products_table_head_data">Product Name</td>
                        <td className="confirm_products_table_head_data">Desgin</td>
                        <td className="confirm_products_table_head_data">Price</td>
                        <td className="confirm_products_table_head_data">Quantity</td>
                        <td className="confirm_products_table_head_data">Total</td>
                    </tr>
                </thead>
                <tbody
                    style={{ borderBottom: showProps ? 'none' : '1px solid #cdcdcd66' }}
                    className="confirm_products_table_body"
                >
                    {products.map((ele) => {
                        return <Component showProps key={ele.name} {...ele} />;
                    })}
                </tbody>
            </table>
            <div style={{ textAlign: 'center', margin: '1rem' }}>
                <button onClick={addMore} style={{ margin: 'auto' }} className="btn-orange ">
                    <p>Add More/Save</p>
                </button>
            </div>
        </div>
    );
};

const Component = ({ id, name, img, notes, desgin, price, quantity, showProps, color, size }) => {
    const { changeQtyCart, updateACartItem } = useUser();
    const [popup, setPopup] = useState(false);

    return (
        <>
            <ImageLibraryAsPopup
                state={popup}
                setStateFalse={() => {
                    setPopup((prev) => !prev);
                }}
                setImage={(value) => {
                    updateACartItem({ id: id, property: 'img', newValue: value });
                }}
            />
            <tr className="confirm_products_table_body_row">
                <td className="confirm_products_table_body_data">
                    <div className="confirm_products_table_body_data_name_details">
                        <p>{name}</p>
                        <div className="confirm_products_table_body_data_name_subdetails">
                            {notes.map((ele) => (
                                <p key={ele}>{ele}</p>
                            ))}
                        </div>
                        {img && (
                            <div className="confirm_products_table_body_data_name_print">
                                <div
                                    onClick={() => {
                                        setPopup((prev) => !prev);
                                    }}
                                    className="confirm_products_table_body_data_name_print-imgcont"
                                >
                                    <img
                                        src={img}
                                        alt="design"
                                        className="confirm_products_table_body_data_name_print-img"
                                    />
                                    <p className="confirm_products_table_body_data_name_print-imghover">
                                        <button>
                                            <EditIcon style={{ color: 'white' }} />
                                        </button>
                                    </p>
                                </div>
                                <p>Printed</p>
                            </div>
                        )}
                    </div>
                </td>
                <td className="confirm_products_table_body_data">
                    <div className="confirm_products_table_body_data_design_details">
                        {!desgin ? (
                            <p>No Design</p>
                        ) : (
                            <DesignPreview front={desgin.front} back={desgin.back} sleeve={desgin.sleeve} />
                        )}
                    </div>
                </td>
                <td className="confirm_products_table_body_data">
                    <div className="confirm_products_table_body_data_price">
                        <p> {`₹ ${price}`}</p> <InfoIcon className="info_icon" />
                    </div>
                </td>
                <td className="confirm_products_table_body_data">
                    <div className="confirm_products_table_body_data_name_subdetails_qty">
                        <RemoveIcon
                            className="confirm_products_table_body_data_name_subdetails_qtyicon"
                            onClick={() => {
                                changeQtyCart({ id, qty: quantity - 1 });
                            }}
                        />
                        <p>{quantity}</p>
                        <AddIcon
                            className="confirm_products_table_body_data_name_subdetails_qtyicon"
                            onClick={() => {
                                changeQtyCart({ id, qty: quantity + 1 });
                            }}
                        />
                    </div>
                </td>
                <td className="confirm_products_table_body_data">
                    <p style={{ width: 'max-content' }}>₹ {price * quantity}</p>
                </td>
            </tr>
            {showProps && <ProductDescription color={color} size={size} id={id} type="view" />}
        </>
    );
};

export default Index;
